/**
 *
 * @param {unknown} error
 * @returns {string}
 */

export function parseDownloadErrorMsg(error) {
  const defaultMsg = 'Uncaught error';
  if (!error) return defaultMsg;

  const errors = error?.data?.errors;

  if (Array.isArray(errors) && errors.length > 0) {
    const messages = errors
      .map((item) => (typeof item === 'string' ? item : item?.detail))
      .filter(Boolean);

    if (messages.length > 0) {
      return messages.join(', ');
    }
  }

  if (typeof error?.data?.message === 'string') {
    return error.data.message;
  }

  if (typeof error?.message === 'string') {
    return error.message;
  }

  if (typeof error?.error === 'string') {
    return error.error;
  }

  return defaultMsg;
}
